"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

if (document.getElementById("app_edit_estate")) {
  var addImageToCurrentEstate = function addImageToCurrentEstate(estate_id, image_id) {
    var dataImages = {
      "estate_ad": estate_id,
      "image": image_id
    };
    $.ajax({
      url: '/api/v1/estate_images',
      type: 'POST',
      data: JSON.stringify(dataImages),
      contentType: 'application/json',
      processData: false,
      success: function success(response) {
        // new Alert().success();
        console.log(response);
      },
      error: function error(_error4) {
        new Alert().warning();
        console.log(_error4);
      }
    });
  };

  var addImageToEstate = function addImageToEstate(id, estate) {
    var dataImages = {
      "estate_ad": estate,
      "image": id
    };
    $.ajax({
      url: '/api/v1/estate_images',
      type: 'POST',
      data: JSON.stringify(dataImages),
      contentType: 'application/json',
      processData: false,
      success: function success(response) {
        var srcImage = response.image_obj.image;
        renderImages(srcImage, response.estate_ad, response.id);
      },
      error: function error(_error5) {
        new Alert().warning();
        deleteImageFromMedias(id, function () {}, function () {});
        console.log(_error5);
      }
    });
  };

  var renderImages = function renderImages(image, estate_id, image_id) {
    var wrapper = $('.js-estate-wrapper'),
        divEl = $('<div class="form-preview mrx js-preview Bg--cover mrs js-async-bg not-loaded" data-src="' + image + '" data-estate="' + estate_id + '" data-image-id="' + image_id + '"></div>'),
        deleteEl = $('<button type="button" class="delete-preview js-delete-preview"><img src="/static/svg/private/close-icon.svg" title="Delete" alt="close icon"/></button>');
    divEl.append(deleteEl);
    wrapper.append(divEl);
    deleteEl.removeImage(image_id);
    asyncBg(function () {
      initAnimation();
    });
  };

  var deleteImageFromMedias = function deleteImageFromMedias(id, successCb, errorCb) {
    $.ajax({
      url: '/api/v1/medias/' + id,
      method: 'DELETE',
      success: function success(response) {
        return successCb(response);
      },
      error: function error(_error6) {
        return errorCb(_error6);
      }
    });
  };

  var deleteImageFromEstate = function deleteImageFromEstate(id, successCb, errorCb) {
    $.ajax({
      url: '/api/v1/estate_images/' + id,
      method: 'DELETE',
      success: function success(response) {
        return deleteImageFromMedias(id, successCb, errorCb);
      },
      error: function error(_error7) {
        return errorCb(_error7);
      }
    });
  };

  var vueEditEstate = new Vue({
    delimiters: ['[[', ']]'],
    el: '#app_edit_estate',
    data: {
      estate: [],
      images: [],
      date: "",
      time: "",
      videoLink: ""
    },
    mounted: function mounted() {
      $.ajaxSetup({
        traditional: true
      });
    },
    methods: {
      getEstate: function getEstate(id) {
        var urlApi = '/api/v1/estate/' + id;
        $.ajax({
          url: urlApi,
          method: 'GET',
          headers: {
            'Accept-Language': languageCode
          },
          success: function success(response) {
            console.log(response);
            var images = response.images_obj.map(function (i) {
              i['is_removed'] = false;
              return i;
            });
            vueEditEstate.images = images;
            vueEditEstate.estate = response;
            CKEDITOR.replace('description', {
              customConfig: confCKeditorBlog
            });
            var audience = response.audience,
                date = "",
                time = "";

            if (audience) {
              date = audience.substring(0, 10);
              time = audience.substring(11, 16);
              $('#audience').val(date);
              $('#audience_hour').val(time);
            }

            if (response.video_id) {
              vueEditEstate.videoLink = 'https://www.youtube.com/watch?v=' + response.video_id;
            }

            setTimeout(function () {
              asyncBg(function () {
                initAnimation();
              });
              vueEditEstate.deleteEstate();
              var category = $('.js-category').val();
              $('.js-youtube-input').videoID();
              $('#type option').each(function () {
                if (category == $(this).val()) {
                  $(this).attr('selected', true);
                  var list = $(this).parent().next().next();
                  list.find('li[data-value=' + category + ']').trigger('click');
                }
              });
            }, 500);
          },
          error: function error(_error) {
            console.log(_error);
          }
        });
      },
      deleteEstate: function deleteEstate() {
        var deleteBtn = $('.js-delete-estate');
        deleteBtn.on('click', function () {
          var id = $(this).data('id'),
              urlEstates = $(this).data('url');
          $.ajax({
            url: '/api/v1/estate/' + id,
            type: 'DELETE',
            success: function success(response) {
              window.location.href = urlEstates;
            },
            error: function error(_error2) {
              console.log(_error2);
            }
          });
        });
      },
      removeImage: function removeImage(id) {
        $('.js-loader').showLoader();
        vueEditEstate.images = vueEditEstate.images.map(function (v) {
          v['is_removed'] = v.id == id;
          return v;
        });
        deleteImageFromEstate(id, function (response) {
          $('.js-loader').hideLoader();
          new Alert().success('Votre image a bien été supprimée.');
          vueEditEstate.images = vueEditEstate.images.filter(function (v) {
            return v.id != id;
          });
        }, function (error) {
          new Alert().warning();
          $('.js-loader').hideLoader();
        });
      },
      postImage: function postImage() {
        var dataImages = {
          "estate_ad": null,
          "image": null
        };
      }
    }
  });
  var postID = $('.js-estate').data('id');

  if (!$('.js-form-estate').hasClass('js-create-estate')) {
    vueEditEstate.getEstate(postID);
  } else {
    CKEDITOR.replace('description', {
      customConfig: confCKeditorBlog
    });
  }

  (function ($) {
    $.fn.updateEstate = function () {
      var that = $(this);
      that.on('submit', function (e) {
        var _dataToSend;

        e.preventDefault();

        if ($(this).hasClass('js-create-estate')) {
          var urlApi = '/api/v1/estate';
          var method = 'POST';
        } else {
          var urlApi = '/api/v1/estate/' + $('.js-estate').data('id');
          var method = 'PUT';
        }

        var date = $('#audience').val(),
            time = $('#audience_hour').val(),
            audience = null;

        if (date && time) {
          audience = date + 'T' + time;
        }

        if (that.hasClass('js-create-estate')) {
          var images = [];
        } else {
          var images = [];
          $('.js-preview').each(function () {
            images.push($(this).data('image-id'));
          });
        }

        var dataToSend = (_dataToSend = {
          "title": $('#title').val(),
          "area": $('#area').val(),
          "rooms": $('#rooms').val(),
          "price": parseInt($('#price').val()),
          "city": $('#city').val(),
          "address": $('#address').val(),
          "department": $('#department option:selected').val(),
          "audience": audience,
          "sale_number": $('#sale_number').val(),
          "images": images,
          "is_published": $('#publish').prop('checked'),
          "description": CKEDITOR.instances['description'].getData(),
          "estate_type": $('#estate_type option:selected').val(),
          "category": $('#type option:selected').val()
        }, _defineProperty(_dataToSend, "sale_number", $('#sale_number').val()), _defineProperty(_dataToSend, "lawyer", parseInt($('#lawyer').val())), _defineProperty(_dataToSend, "video_id", $('#video').attr('data-video-id')), _dataToSend);
        $.ajax({
          url: urlApi,
          type: method,
          data: JSON.stringify(dataToSend),
          cache: false,
          contentType: 'application/json',
          processData: false,
          headers: {
            'Accept-Language': languageCode
          },
          success: function success(response) {
            if (that.hasClass('js-create-estate')) {
              var estate_id = response.id;
              $('.js-preview').each(function () {
                var image_id = $(this).data('image-id');
                addImageToCurrentEstate(response.id, image_id);
              });
              $('.js-notification').addClass('show');
              setTimeout(function () {
                $('.js-notification').removeClass('show');
                window.location.replace(that.data('success'));
              }, 1500);
            } else {
              $('.js-notification').addClass('show');
              setTimeout(function () {
                $('.js-notification').removeClass('show');
              }, 1500);
            }
          },
          error: function error(_error3) {
            var errors = _error3.responseJSON;
            new Alert().error();

            for (_error3 in errors) {
              $('[data-error="' + _error3 + '"]').addClass('has-error');
            }
          }
        });
      });
    };
  })(jQuery);

  (function ($) {
    $.fn.showLoader = function () {
      $(this).show();
      $(this).addClass('animated');
    };

    $.fn.hideLoader = function () {
      $(this).hide();
      $(this).removeClass('animated');
    };

    $.fn.removeImage = function (image_id) {
      var $that = $(this);
      $that.on('click', function () {
        var _this = this;

        var fn = $('.js-form-estate').hasClass('js-create-estate') ? deleteImageFromMedias : deleteImageFromEstate;
        $('.js-loader').showLoader();
        $that.closest('.js-preview').addClass('is-removed');
        fn(image_id, function (response) {
          $('.js-loader').hideLoader();
          new Alert().success('Votre image a bien été supprimée.');
          $(_this).parent().remove();
        }, function (error) {
          new Alert().warning();
          $('.js-loader').hideLoader();
        });
      });
    };

    $.fn.changeEstateImages = function () {
      var that = $(this);
      that.on('change', function () {
        var formData = new FormData($('.js-form-article')),
            estate_id = $(this).data('estate'),
            input = $(this);
        formData.append('image', $(this)[0].files[0]);
        formData.append('attachment', $(this)[0].files[0]);
        formData.append("csrfmiddlewaretoken", $('[name="csrfmiddlewaretoken"]').val());
        $.ajax({
          url: '/api/v1/medias',
          type: 'POST',
          data: formData,
          cache: false,
          contentType: false,
          processData: false,
          beforeSend: function beforeSend() {
            $('.js-loader').showLoader();
          },
          success: function success(response) {
            var id_image = response.id,
                image = response.image;

            if (input.hasClass('js-creation')) {
              renderImages(image, null, id_image);
            } else {
              addImageToEstate(id_image, estate_id);
            }

            $('.js-loader').hideLoader();
            new Alert().success();
          },
          error: function error(_error8) {
            $('.js-loader').hideLoader();
            new Alert().warning();
            console.log(_error8);
          }
        });
      });
    };

    $.fn.initAttachment = function () {
      $(this).on('submit', function (e) {
        var that = this;
        e.preventDefault();

        if (vueEditEstate.estate.id) {
          sendAttachment(that);
        } else {
          vueEditEstate.submit(e, function () {
            return sendAttachment(that);
          });
        }
      });
    };
  })(jQuery);

  $(function () {
    /*if ($('.js-form-estate').length) {
        $('.js-form-estate').updateEstate();
    }
    if ($('.js-estate-images').length) {
        $('.js-estate-images').changeEstateImages();
    }
    if ($('.js-delete-preview').length) {
        $('.js-delete-preview').removeImage();
    }*/
  });
}